<template>
    <canvas width="400" height="250"></canvas>
</template>

<script>
    import datalabels from 'chartjs-plugin-datalabels'
    import moment from 'moment'
    import Chart from 'chart.js'

    export default {
        props: ['year', 'rows', 'loading'],

        mounted() {
            this.$nextTick(this.draw)
        },

        watch: {
            loading() {
                this.$nextTick(this.draw)
            }
        },

        computed: {
            datasets() {
                return [
                    {
                        label: 'Subscriptions',
                        data: this.getPaddedColumn(this.column),
                        backgroundColor: '#20aaea'
                    }
                ]
            },

            column() {
                return this.rows.reduce((result, row) => {
                    result[row.month] = row.subscription_month_count

                    return result
                }, {})
            },

            months() {
                let startDate = moment().year(this.year).startOf('year')

                let endDate = moment().year(this.year).endOf('year')

                let result = []

                while (startDate.isBefore(endDate)) {
                    result.push(startDate.clone())

                    startDate.add(1, 'month')
                }

                return result
            },

            labels() {
                return this.months.map(month => month.format('MMMM'))
            }
        },

        methods: {
            draw() {
                new Chart(this.$el.getContext('2d'), {
                    type: 'bar',

                    data: {
                        labels: this.labels,
                        datasets: this.datasets
                    },

                    options: {
                        scales: {
                            xAxes: [{
                                stacked: true
                            }],
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },

                        legend: {
                            position: 'bottom'
                        },

                        layout: {
                            padding: {
                                top: 25
                            }
                        },

                        tooltips: {
                            callbacks: {
                                label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + d.datasets[t.datasetIndex].data[t.index]
                            }
                        },

                        plugins: {
                            datalabels: {
                                anchor: 'end',
                                align: 'end'
                            }
                        },
                    }
                });
            },

            getPaddedColumn(column) {
                return Object.values({...this.getDefaultColumn(), ...column})
            },

            getDefaultColumn() {
                return this.months.reduce((result, month) => {
                    result[month.format('YYYY-MM')] = 0

                    return result
                }, {})
            }
        }
    }
</script>
